/**
 * Created by mgoria on 1/29/16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RumEventValidationException = undefined;

var _LogDriverException2 = require('./LogDriverException');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Thrown when RUM event is invalid
 */
let RumEventValidationException = exports.RumEventValidationException = function (_LogDriverException) {
  _inherits(RumEventValidationException, _LogDriverException);

  /**
   * @param {String} eventLevel
   * @param {Object} error
   */
  function RumEventValidationException(eventLevel, error) {
    _classCallCheck(this, RumEventValidationException);

    return _possibleConstructorReturn(this, (RumEventValidationException.__proto__ || Object.getPrototypeOf(RumEventValidationException)).call(this, `Failed to validate "${eventLevel}" event: ${error}`));
  }

  return RumEventValidationException;
}(_LogDriverException2.LogDriverException);


//////////////////
// WEBPACK FOOTER
// ../~/deep-log/lib.compiled/Driver/Exception/RumEventValidationException.js
// module id = 403
// module chunks = 0